function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TableauDatasourceService from '@/apps/data-platform/services/visualization/tbl_datasource_service';
import { textsDefaul, envConfig, ENVIRONMENT_FLOW, ACCESS_TYPE_FLOW } from '@/js/constants';
import utils from '@/js/utils';
import SearchTableau from '@/components/SearchTableau';
import PaginationTableau from '@/components/PaginationTableau';
import FormMetaDatasource from '@/components/tableau/FormMetaDatasource';
import { Tableau } from '@/mixins/tableau.js';
import FormAssignTemporalOwner from '@/components/FormAssignTemporalOwner.vue';
export default {
  name: 'ContMyDatasources',
  mixins: [Tableau],
  components: {
    SearchTableau: SearchTableau,
    PaginationTableau: PaginationTableau,
    FormMetaDatasource: FormMetaDatasource,
    FormAssignTemporalOwner: FormAssignTemporalOwner
  },
  data: function data() {
    return {
      collapse_filter: false,
      isBusy: false,
      messageLoading: textsDefaul.LOADING,
      messageEmptyList: textsDefaul.NOT_DATASOURCES,
      defaultDomain2: null,
      tableau_datasource: null,
      messageEmptyTableauDs: textsDefaul.LOADING,
      title_modal: '',
      data_ds: null,
      path_name: '',
      limit: envConfig.pagintaionSize,
      pageDs: 1,
      totalRowsDs: 0,
      isReadonly: false,
      MODAL_NAME_OWNER: 'ContDatasourceMeOwner',
      MODAL_NAME_ALL_OWNER: 'ContDatasourcesMeOwnerAll',
      MODAL_NAME_DATASOURCE: 'modalchangeMetaDataSource',
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW
    };
  },
  props: {
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    dataSourceFields: function dataSourceFields() {
      return [{
        key: '↕',
        variant: 'return-sort',
        class: 'w-3'
      }, {
        label: 'Datasource',
        key: 'object_name',
        sortable: true,
        class: 'text-left w-30'
      }, {
        label: this.traductor('tablas.enviroment'),
        key: 'environment',
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.columns'),
        key: 'columns.length',
        class: 'w-7',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.total'),
        key: 'total_tables',
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.creation_time'),
        key: 'creation_date',
        class: 'w-15',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.actions'),
        key: 'actions',
        class: 'text-left w-15',
        align: 'center'
      }, {
        label: this.traductor('tablas.rol'),
        key: 'rol',
        class: 'w-10',
        align: 'center'
      }];
    },
    isEmptyWorkDs: function isEmptyWorkDs() {
      return !(this.tableau_datasource && this.tableau_datasource.length);
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    isDataOperator: function isDataOperator() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return item.data_operator === window.userInfo.email;
      };
    },
    showAssignDataOperator: function showAssignDataOperator() {
      return function (item) {
        // return item.owner_email === window.userInfo.email && item.environment === ENVIRONMENT_FLOW.PROD
        return item.environment === ENVIRONMENT_FLOW.PROD;
      };
    },
    hideAssignAllTables: function hideAssignAllTables() {
      var list_env = [];
      var data = {};
      if (this.tableau_datasource && this.tableau_datasource.length) {
        var _iterator = _createForOfIteratorHelper(this.tableau_datasource),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var table = _step.value;
            data = {
              env: table.environment,
              operator: table.data_operator
            };
            list_env.push(data);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return list_env.some(function (item) {
        return item.env === 'prod' && item.operator === window.userInfo.email;
      });
    }
  },
  created: function created() {
    if (window.userInfo.isSignIn) {
      window.userInfo.isSignIn = false;
      setTimeout(function () {
        location.reload();
      }, 1000);
    }
    if (window.userInfo.isSignIn === undefined) {
      this.reloadTableauDataSource();
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSearchQueryDataSource: function onSearchQueryDataSource(data) {
      this.reloadTableauDataSource(data);
    },
    processParams: function processParams(params) {
      return _objectSpread({
        domain: window.userInfo.domain,
        limit: this.limit,
        page: this.pageDs,
        filters: [{
          key: 'data_operator',
          operator: '==',
          value: window.userInfo.email
        }]
      }, params);
    },
    reloadTableauDataSource: function reloadTableauDataSource(params) {
      var _this = this;
      this.isBusy = true;
      this.tableau_datasource = [];
      this.totalRowsDs = 0;
      var defaultParams = this.processParams(params);
      TableauDatasourceService.tableauDataSourceQuery(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this.tableau_datasource = res.data.result;
          _this.totalRowsDs = res.data.total;
          _this.pageDs = res.data.page;
          _this.messageEmptyTableauDs = res.data.result.length === 0 ? textsDefaul.NOT_DATASOURCES : null;
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      }).finally(function () {
        _this.isBusy = false;
      });
    },
    changeMetaDataSource: function changeMetaDataSource(item) {
      var readonly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.title_modal = "DATASOURCE: ".concat(item.path_name, "/").concat(item.object_name);
      this.data_ds = utils.cloneJSON(item);
      this.path_name = item.path_name;
      this.isReadonly = readonly;
      this.$bvModal.show(this.MODAL_NAME_DATASOURCE);
    },
    onCloseModalDataSource: function onCloseModalDataSource() {
      this.$bvModal.hide(this.MODAL_NAME_DATASOURCE);
    },
    onPageDataSource: function onPageDataSource(page) {
      this.pageDs = page;
      this.reloadTableauDataSource({
        page: page
      });
    },
    openAllTempOwner: function openAllTempOwner() {
      this.$bvModal.show(this.MODAL_NAME_ALL_OWNER);
      return true;
    },
    openTempOwner: function openTempOwner(item) {
      this.data_ds = item;
      this.$bvModal.show(this.MODAL_NAME_OWNER);
      return true;
    },
    assignOwner: function assignOwner() {
      this.reloadTableauDataSource();
      this.$bvModal.hide(this.MODAL_NAME_OWNER);
      return true;
    },
    assignAllOwner: function assignAllOwner() {
      this.reloadTableauDataSource();
      this.$bvModal.hide(this.MODAL_NAME_ALL_OWNER);
      return true;
    }
  }
};